import React from "react";
import * as s from "./ClientsControl.styles";
import { useHistory } from "react-router-dom";

//  components
import LineProgressBar from "../../../../shared/lineProgressBar/LineProgressBar";

const ClientsControl = (props) => {
  const { id, name, email, phoneNumber, complete } = props;
  const history = useHistory();
  return (
    <s.ClientContainer onClick={() => history.push(`/clients/${id}`)}>
      <s.H1>{name}</s.H1>
      <s.Span>{email}</s.Span>
      <s.Span>{phoneNumber}</s.Span>
      <s.ProgressBarContainer>
        <LineProgressBar complete={complete} />
      </s.ProgressBarContainer>
    </s.ClientContainer>
  );
};

export default ClientsControl;
